<template>
  <div class="page-header no-print" v-if="$route.path != '/index'">
    <div class="breadcrumb">
      <div class="page-wide">
        <a-breadcrumb separator=">">
          <a-breadcrumb-item class="position">当前位置：</a-breadcrumb-item>
          <a-breadcrumb-item :key="item.path || item.name" v-for="(item, index) in breadcrumb">
            <template v-if="index === 0">
              <span v-if="item.name === '报修申请' || item.name === '我的报修' || item.name === '系统设置'">{{item.name}}</span>
              <router-link :to="item.redirect || '/'" v-else-if="item.name !== '后台管理'">{{item.name}}</router-link>
            </template>
            <template v-else-if="item.redirect">
              <router-link :to="item.redirect">{{item.name}}</router-link>
            </template>
            <template v-else>{{item.name}}</template>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    breadcrumb: {
      type: Array,
      required: false
    }
  }
}
</script>
